/**
 * @generated SignedSource<<bc27f5048305cb1c5bf7ffee0e372368>>
 * @relayHash 6c005db37c94b75f5a659af33e109ffb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 862c92ef7fb9eeac5cb31a0bf3a983f9bde67a5e1dcaeb68a2208370b45811f0

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraIssueSearchOperationScope = "NIN_GLOBAL" | "NIN_GLOBAL_SCHEMA_REFACTOR" | "NIN_GLOBAL_SHADOW_REQUEST" | "NIN_PROJECT" | "NIN_PROJECT_SCHEMA_REFACTOR" | "NIN_PROJECT_SHADOW_REQUEST" | "TIMELINE_PROJECT" | "%future added value";
export type JiraSoftwareIssueSearchCustomInputContext = "BACKLOG" | "BOARD" | "NONE" | "%future added value";
export type JiraIssueSearchFieldSetsInput = {
  fieldSetIds?: ReadonlyArray<string> | null | undefined;
  viewInput?: JiraIssueSearchViewInput | null | undefined;
};
export type JiraIssueSearchViewInput = {
  context?: JiraIssueSearchViewFieldSetsContext | null | undefined;
  filterId?: string | null | undefined;
  namespace?: string | null | undefined;
  viewId?: string | null | undefined;
};
export type JiraIssueSearchViewFieldSetsContext = {
  filterContext?: JiraIssueSearchViewFieldSetFilterContext | null | undefined;
  issueContext?: JiraIssueSearchViewFieldSetsIssueContext | null | undefined;
  projectContext?: JiraIssueSearchViewFieldSetsProjectContext | null | undefined;
};
export type JiraIssueSearchViewFieldSetFilterContext = {
  filter?: string | null | undefined;
};
export type JiraIssueSearchViewFieldSetsIssueContext = {
  issueKey?: string | null | undefined;
};
export type JiraIssueSearchViewFieldSetsProjectContext = {
  issueType?: string | null | undefined;
  project?: string | null | undefined;
};
export type JiraIssueSearchInput = {
  childIssuesInput?: JiraIssueSearchChildIssuesInput | null | undefined;
  customInput?: JiraIssueSearchCustomInput | null | undefined;
  filterId?: string | null | undefined;
  jql?: string | null | undefined;
  searchWithLastUsedJql?: boolean | null | undefined;
};
export type JiraIssueSearchChildIssuesInput = {
  filterByProjectKeys?: ReadonlyArray<string> | null | undefined;
  filterId?: string | null | undefined;
  jql?: string | null | undefined;
  namespace?: string | null | undefined;
  parentIssueKey: string;
  viewId?: string | null | undefined;
};
export type JiraIssueSearchCustomInput = {
  jiraSoftwareInput?: JiraSoftwareIssueSearchCustomInput | null | undefined;
  jiraTimelineInput?: JiraTimelineIssueSearchCustomInput | null | undefined;
};
export type JiraSoftwareIssueSearchCustomInput = {
  additionalJql?: string | null | undefined;
  context?: JiraSoftwareIssueSearchCustomInputContext | null | undefined;
  jiraEntityId: string;
};
export type JiraTimelineIssueSearchCustomInput = {
  additionalJql?: string | null | undefined;
  boardId: string;
  customFilterIds?: ReadonlyArray<string> | null | undefined;
  quickFilterIds?: ReadonlyArray<string> | null | undefined;
};
export type JiraIssueSearchOptions = {
  issueKey?: string | null | undefined;
};
export type JiraIssueSearchScope = {
  operationScope?: JiraIssueSearchOperationScope | null | undefined;
  projectKey?: string | null | undefined;
};
export type JiraIssueSearchSettings = {
  groupBy?: string | null | undefined;
  hideDone?: boolean | null | undefined;
  hierarchyEnabled?: boolean | null | undefined;
  jql?: string | null | undefined;
};
export type IssueNavigatorJiraDetailedViewPaginationQuery$variables = {
  after?: string | null | undefined;
  before?: string | null | undefined;
  dynamicSearchKey?: string | null | undefined;
  fieldSetsInput?: JiraIssueSearchFieldSetsInput | null | undefined;
  first?: number | null | undefined;
  id: string;
  isConditionalFormattingEnabled: boolean;
  issueSearchInput: JiraIssueSearchInput;
  last?: number | null | undefined;
  options?: JiraIssueSearchOptions | null | undefined;
  projectKey?: string | null | undefined;
  projectKeys?: ReadonlyArray<string> | null | undefined;
  saveJQLToUserHistory?: boolean | null | undefined;
  scope?: JiraIssueSearchScope | null | undefined;
  settings?: JiraIssueSearchSettings | null | undefined;
};
export type IssueNavigatorJiraDetailedViewPaginationQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_IssueNavigator_jiraDetailedViewData">;
  } | null | undefined;
};
export type IssueNavigatorJiraDetailedViewPaginationQuery = {
  response: IssueNavigatorJiraDetailedViewPaginationQuery$data;
  variables: IssueNavigatorJiraDetailedViewPaginationQuery$variables;
};
({
  "__relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider": isBulkOpsSelectAllEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider": isReparentingEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcfrontierformulafieldd1relayprovider": isFormulaFieldD1Enabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider": isInitialiseVirtualiserStateFromRelayStoreEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcmimicflatlistrsswhileuninitialisedrelayprovider": isMimicFlatlistRssWhileUninitialisedEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreducererendersrelayprovider": isJiraListReduceRerendersEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": isJscMergedColumnEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": isJiraItrM4Exp3Enabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider": isIframePreviewPanelInSubtasksEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider": isJiraTimelineAnalyticsHarmonizationEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider": isAtlasProjectEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider": originalEstimateEditableFixFlag_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": isFieldsByIdRemoved_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider": shouldFetchAppUserType_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider": isJiraAiAgentAvatarSingleUserPickerEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider": isNinStrikethroughResolutionUpdateEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": isNumberFieldConfigurableEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider": isPlaceholderDataEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": isJiraConfluencePageContentEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider": isJiraTimelineRollupsTechnicalGateEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerninrelayprovider": isJiraAiAgentAvatarSingleUserPickerNINEnabled_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcfrontierformulafieldd1relayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerninrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiralistreducererendersrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcmimicflatlistrsswhileuninitialisedrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider: {
    readonly get: () => boolean;
  };
});

import isAtlasProjectEnabled_provider from '@atlassian/jira-relay-provider/src/atlas-project-native-integration.relayprovider';
import isBulkOpsSelectAllEnabled_provider from '@atlassian/jira-relay-provider/src/bulk-ops-select-all.relayprovider';
import isFormulaFieldD1Enabled_provider from '@atlassian/jira-relay-provider/src/frontier-formula-field-d1.relayprovider';
import isPlaceholderDataEnabled_provider from '@atlassian/jira-relay-provider/src/goals-ssr-smart-card.relayprovider';
import isInitialiseVirtualiserStateFromRelayStoreEnabled_provider from '@atlassian/jira-relay-provider/src/initialise-virtualiser-state-from-relay-store.relayprovider';
import isIframePreviewPanelInSubtasksEnabled_provider from '@atlassian/jira-relay-provider/src/is-iframe-preview-panel-in-subtasks-enabled.relayprovider';
import isJiraItrM4Exp3Enabled_provider from '@atlassian/jira-relay-provider/src/is-jira-itr-m4-exp-3-enabled.relayprovider';
import isFieldsByIdRemoved_provider from '@atlassian/jira-relay-provider/src/issue-view-dfo-remove-fields-by-id.relayprovider';
import isJiraAiAgentAvatarSingleUserPickerNINEnabled_provider from '@atlassian/jira-relay-provider/src/jira-ai-agent-avatar-single-user-picker-nin.relayprovider';
import isJiraAiAgentAvatarSingleUserPickerEnabled_provider from '@atlassian/jira-relay-provider/src/jira-ai-agent-avatar-single-user-picker.relayprovider';
import shouldFetchAppUserType_provider from '@atlassian/jira-relay-provider/src/jira-ai-fetch-apptype-for-user-assignee.relayprovider';
import isJiraConfluencePageContentEnabled_provider from '@atlassian/jira-relay-provider/src/jira-confluence-page-content-enabled.relayprovider';
import isJiraListReduceRerendersEnabled_provider from '@atlassian/jira-relay-provider/src/jira-list-reduce-rerenders.relayprovider';
import isReparentingEnabled_provider from '@atlassian/jira-relay-provider/src/jira-list-reparenting.relayprovider';
import isNumberFieldConfigurableEnabled_provider from '@atlassian/jira-relay-provider/src/jira-number-field-configuration-enabled.relayprovider';
import originalEstimateEditableFixFlag_provider from '@atlassian/jira-relay-provider/src/jira-original-estimate-editable-fix.relayprovider';
import isJiraTimelineAnalyticsHarmonizationEnabled_provider from '@atlassian/jira-relay-provider/src/jira-timeline-analytics-harmonization.relayprovider';
import isJiraTimelineRollupsTechnicalGateEnabled_provider from '@atlassian/jira-relay-provider/src/jira-timeline-rollups-technical-gate.relayprovider';
import isJscMergedColumnEnabled_provider from '@atlassian/jira-relay-provider/src/jsc-merged-column.relayprovider';
import isMimicFlatlistRssWhileUninitialisedEnabled_provider from '@atlassian/jira-relay-provider/src/mimic-flatlist-rss-while-uninitialised.relayprovider';
import isNinStrikethroughResolutionUpdateEnabled_provider from '@atlassian/jira-relay-provider/src/nin-resolution-strikethough-enabled.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "before"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dynamicSearchKey"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fieldSetsInput"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isConditionalFormattingEnabled"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueSearchInput"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "last"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "options"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKey"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKeys"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "saveJQLToUserHistory"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "scope"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "settings"
},
v15 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v16 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v17 = {
  "kind": "ScalarField",
  "name": "id"
},
v18 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "before",
    "variableName": "before"
  },
  {
    "kind": "Variable",
    "name": "fieldSetsInput",
    "variableName": "fieldSetsInput"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "issueSearchInput",
    "variableName": "issueSearchInput"
  },
  {
    "kind": "Variable",
    "name": "last",
    "variableName": "last"
  },
  {
    "kind": "Variable",
    "name": "options",
    "variableName": "options"
  },
  {
    "kind": "Variable",
    "name": "saveJQLToUserHistory",
    "variableName": "saveJQLToUserHistory"
  },
  {
    "kind": "Variable",
    "name": "scope",
    "variableName": "scope"
  },
  {
    "kind": "Variable",
    "name": "settings",
    "variableName": "settings"
  }
],
v19 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v20 = {
  "kind": "ScalarField",
  "name": "key"
},
v21 = {
  "kind": "ScalarField",
  "name": "issueId"
},
v22 = {
  "concreteType": "JiraIssueTypeHierarchyLevel",
  "kind": "LinkedField",
  "name": "hierarchy",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "level"
    }
  ]
},
v23 = {
  "kind": "ScalarField",
  "name": "isResolved"
},
v24 = {
  "kind": "ScalarField",
  "name": "statusCategoryId"
},
v25 = {
  "concreteType": "JiraStatusCategory",
  "kind": "LinkedField",
  "name": "statusCategory",
  "plural": false,
  "selections": [
    (v24/*: any*/),
    (v17/*: any*/)
  ]
},
v26 = {
  "concreteType": "JiraStatus",
  "kind": "LinkedField",
  "name": "status",
  "plural": false,
  "selections": [
    (v25/*: any*/),
    (v17/*: any*/)
  ]
},
v27 = {
  "concreteType": "JiraStatusField",
  "kind": "LinkedField",
  "name": "statusField",
  "plural": false,
  "selections": [
    (v26/*: any*/),
    (v17/*: any*/)
  ]
},
v28 = {
  "kind": "ScalarField",
  "name": "name"
},
v29 = [
  (v28/*: any*/)
],
v30 = {
  "kind": "ScalarField",
  "name": "__id"
},
v31 = {
  "kind": "ScalarField",
  "name": "summary"
},
v32 = {
  "concreteType": "JiraAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "small"
    }
  ]
},
v33 = {
  "kind": "ScalarField",
  "name": "type"
},
v34 = {
  "kind": "ScalarField",
  "name": "totalCount"
},
v35 = {
  "kind": "ScalarField",
  "name": "fieldId"
},
v36 = {
  "kind": "ScalarField",
  "name": "value"
},
v37 = [
  (v36/*: any*/),
  (v17/*: any*/),
  {
    "kind": "ScalarField",
    "name": "isDisabled"
  }
],
v38 = {
  "kind": "ScalarField",
  "name": "lazyIsEditableInIssueView"
},
v39 = {
  "kind": "ClientExtension",
  "selections": [
    (v38/*: any*/)
  ]
},
v40 = {
  "kind": "ScalarField",
  "name": "message"
},
v41 = [
  (v40/*: any*/)
],
v42 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
],
v43 = {
  "alias": "value",
  "kind": "ScalarField",
  "name": "id"
},
v44 = {
  "alias": "label",
  "kind": "ScalarField",
  "name": "name"
},
v45 = {
  "kind": "ScalarField",
  "name": "date"
},
v46 = {
  "concreteType": "JiraFieldConfig",
  "kind": "LinkedField",
  "name": "fieldConfig",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isRequired"
    }
  ]
},
v47 = {
  "kind": "ScalarField",
  "name": "text"
},
v48 = {
  "concreteType": "JiraColor",
  "kind": "LinkedField",
  "name": "color",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "colorKey"
    },
    (v17/*: any*/)
  ]
},
v49 = {
  "concreteType": "JiraAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "xsmall"
    }
  ]
},
v50 = {
  "kind": "ScalarField",
  "name": "webUrl"
},
v51 = {
  "kind": "ScalarField",
  "name": "issueTypeId"
},
v52 = {
  "kind": "ScalarField",
  "name": "picture"
},
v53 = {
  "kind": "ScalarField",
  "name": "accountStatus"
},
v54 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v55 = [
  {
    "kind": "ScalarField",
    "name": "appType"
  }
],
v56 = [
  {
    "kind": "TypeDiscriminator",
    "abstractKey": "__isUser"
  },
  {
    "kind": "InlineFragment",
    "selections": (v55/*: any*/),
    "type": "AppUser"
  }
],
v57 = {
  "kind": "ScalarField",
  "name": "optionId"
},
v58 = {
  "kind": "ClientExtension",
  "selections": [
    (v30/*: any*/)
  ]
},
v59 = {
  "concreteType": "JiraEstimate",
  "kind": "LinkedField",
  "name": "originalEstimate",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "timeInSeconds"
    }
  ]
},
v60 = {
  "concreteType": "JiraTimeTrackingSettings",
  "kind": "LinkedField",
  "name": "timeTrackingSettings",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "workingHoursPerDay"
    },
    {
      "kind": "ScalarField",
      "name": "workingDaysPerWeek"
    },
    {
      "kind": "ScalarField",
      "name": "defaultFormat"
    },
    {
      "kind": "ScalarField",
      "name": "defaultUnit"
    }
  ]
},
v61 = {
  "kind": "ScalarField",
  "name": "versionId"
},
v62 = [
  (v17/*: any*/)
],
v63 = {
  "concreteType": "JiraIssue",
  "kind": "LinkedField",
  "name": "issue",
  "plural": false,
  "selections": (v62/*: any*/)
},
v64 = {
  "kind": "ScalarField",
  "name": "href"
},
v65 = [
  {
    "kind": "Literal",
    "name": "viewId",
    "value": "list_default"
  }
],
v66 = {
  "kind": "InlineFragment",
  "selections": [
    (v45/*: any*/)
  ],
  "type": "JiraDatePickerField"
},
v67 = [
  (v16/*: any*/),
  (v35/*: any*/),
  (v66/*: any*/),
  (v17/*: any*/)
],
v68 = [
  (v16/*: any*/),
  (v66/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": (v62/*: any*/),
    "type": "Node",
    "abstractKey": "__isNode"
  }
],
v69 = [
  (v16/*: any*/),
  (v17/*: any*/)
],
v70 = {
  "kind": "ScalarField",
  "name": "pageNumber"
},
v71 = {
  "kind": "ScalarField",
  "name": "isCurrent"
},
v72 = [
  (v70/*: any*/),
  (v19/*: any*/),
  (v71/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/)
    ],
    "kind": "Fragment",
    "name": "IssueNavigatorJiraDetailedViewPaginationQuery",
    "selections": [
      {
        "args": (v15/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "isConditionalFormattingEnabled",
                "variableName": "isConditionalFormattingEnabled"
              },
              {
                "kind": "Variable",
                "name": "projectKey",
                "variableName": "projectKey"
              },
              {
                "kind": "Variable",
                "name": "projectKeys",
                "variableName": "projectKeys"
              }
            ],
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_IssueNavigator_jiraDetailedViewData"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v5/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcfrontierformulafieldd1relayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcmimicflatlistrsswhileuninitialisedrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreducererendersrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerninrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "IssueNavigatorJiraDetailedViewPaginationQuery",
    "selections": [
      {
        "args": (v15/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v16/*: any*/),
          (v17/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": (v18/*: any*/),
                "concreteType": "JiraIssueConnection",
                "kind": "LinkedField",
                "name": "issues",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraIssueEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      (v19/*: any*/),
                      {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v16/*: any*/),
                          (v17/*: any*/),
                          (v20/*: any*/),
                          (v21/*: any*/),
                          {
                            "concreteType": "JiraIssueTypeField",
                            "kind": "LinkedField",
                            "name": "issueTypeField",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraIssueType",
                                "kind": "LinkedField",
                                "name": "issueType",
                                "plural": false,
                                "selections": [
                                  (v22/*: any*/),
                                  (v17/*: any*/)
                                ]
                              },
                              (v17/*: any*/)
                            ]
                          },
                          (v23/*: any*/),
                          (v27/*: any*/),
                          {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "concreteType": "JiraIssueTypeField",
                                "kind": "LinkedField",
                                "name": "issueTypeField",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraIssueType",
                                    "kind": "LinkedField",
                                    "name": "issueType",
                                    "plural": false,
                                    "selections": (v29/*: any*/)
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "kind": "ClientExtension",
                            "selections": [
                              (v30/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "isHighlightedIssueRow"
                              }
                            ]
                          },
                          {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              (v31/*: any*/),
                              {
                                "concreteType": "JiraIssueTypeField",
                                "kind": "LinkedField",
                                "name": "issueTypeField",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraIssueType",
                                    "kind": "LinkedField",
                                    "name": "issueType",
                                    "plural": false,
                                    "selections": [
                                      (v32/*: any*/),
                                      {
                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": (v29/*: any*/)
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v16/*: any*/),
                      {
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "first",
                            "value": 500
                          }
                        ],
                        "concreteType": "JiraIssueFieldSetConnection",
                        "kind": "LinkedField",
                        "name": "fieldSets",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JiraIssueFieldSetEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "JiraIssueFieldSet",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v33/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "fieldSetId"
                                  },
                                  {
                                    "concreteType": "JiraIssueFieldConnection",
                                    "kind": "LinkedField",
                                    "name": "fields",
                                    "plural": false,
                                    "selections": [
                                      (v34/*: any*/),
                                      {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v17/*: any*/),
                                              (v16/*: any*/),
                                              (v35/*: any*/),
                                              (v33/*: any*/),
                                              {
                                                "kind": "TypeDiscriminator",
                                                "abstractKey": "__isJiraIssueField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraAffectedServiceConnection",
                                                    "kind": "LinkedField",
                                                    "name": "selectedAffectedServicesConnection",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraAffectedServiceEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraAffectedService",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                              {
                                                                "kind": "ScalarField",
                                                                "name": "serviceId"
                                                              },
                                                              (v28/*: any*/),
                                                              (v17/*: any*/)
                                                            ]
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraAffectedServicesField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v28/*: any*/),
                                                  {
                                                    "concreteType": "JiraCascadingOption",
                                                    "kind": "LinkedField",
                                                    "name": "cascadingOption",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraOption",
                                                        "kind": "LinkedField",
                                                        "name": "parentOptionValue",
                                                        "plural": false,
                                                        "selections": (v37/*: any*/)
                                                      },
                                                      {
                                                        "concreteType": "JiraOption",
                                                        "kind": "LinkedField",
                                                        "name": "childOptionValue",
                                                        "plural": false,
                                                        "selections": (v37/*: any*/)
                                                      }
                                                    ]
                                                  },
                                                  (v39/*: any*/)
                                                ],
                                                "type": "JiraCascadingSelectField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraCmdbObjectConnection",
                                                    "kind": "LinkedField",
                                                    "name": "selectedCmdbObjectsConnection",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraCmdbObjectEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraCmdbObject",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                              {
                                                                "kind": "ScalarField",
                                                                "name": "objectId"
                                                              },
                                                              {
                                                                "kind": "ScalarField",
                                                                "name": "label"
                                                              },
                                                              {
                                                                "concreteType": "JiraCmdbAvatar",
                                                                "kind": "LinkedField",
                                                                "name": "avatar",
                                                                "plural": false,
                                                                "selections": [
                                                                  {
                                                                    "concreteType": "JiraCmdbMediaClientConfig",
                                                                    "kind": "LinkedField",
                                                                    "name": "mediaClientConfig",
                                                                    "plural": false,
                                                                    "selections": [
                                                                      {
                                                                        "kind": "ScalarField",
                                                                        "name": "clientId"
                                                                      },
                                                                      {
                                                                        "kind": "ScalarField",
                                                                        "name": "fileId"
                                                                      },
                                                                      {
                                                                        "kind": "ScalarField",
                                                                        "name": "mediaBaseUrl"
                                                                      },
                                                                      {
                                                                        "kind": "ScalarField",
                                                                        "name": "mediaJwtToken"
                                                                      }
                                                                    ]
                                                                  },
                                                                  {
                                                                    "kind": "ScalarField",
                                                                    "name": "url48"
                                                                  }
                                                                ]
                                                              }
                                                            ]
                                                          }
                                                        ]
                                                      },
                                                      {
                                                        "concreteType": "QueryError",
                                                        "kind": "LinkedField",
                                                        "name": "errors",
                                                        "plural": true,
                                                        "selections": (v41/*: any*/)
                                                      }
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraCMDBField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v28/*: any*/),
                                                  {
                                                    "args": (v42/*: any*/),
                                                    "concreteType": "JiraComponentConnection",
                                                    "kind": "LinkedField",
                                                    "name": "selectedComponentsConnection",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraComponentEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraComponent",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                              (v43/*: any*/),
                                                              (v44/*: any*/),
                                                              (v17/*: any*/)
                                                            ]
                                                          }
                                                        ]
                                                      }
                                                    ],
                                                    "storageKey": "selectedComponentsConnection(first:1000)"
                                                  },
                                                  (v39/*: any*/)
                                                ],
                                                "type": "JiraComponentsField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v45/*: any*/),
                                                  (v28/*: any*/),
                                                  (v46/*: any*/),
                                                  (v39/*: any*/)
                                                ],
                                                "type": "JiraDatePickerField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "dateTime"
                                                  },
                                                  (v28/*: any*/),
                                                  (v39/*: any*/)
                                                ],
                                                "type": "JiraDateTimePickerField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraEpic",
                                                    "kind": "LinkedField",
                                                    "name": "epic",
                                                    "plural": false,
                                                    "selections": [
                                                      (v20/*: any*/),
                                                      (v31/*: any*/),
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "color"
                                                      },
                                                      (v17/*: any*/)
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraEpicLinkField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "renderedFieldHtml"
                                                  }
                                                ],
                                                "type": "JiraFallbackField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v47/*: any*/),
                                                  (v28/*: any*/),
                                                  (v39/*: any*/)
                                                ],
                                                "type": "JiraSingleLineTextField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraStatusCategory",
                                                    "kind": "LinkedField",
                                                    "name": "statusCategory",
                                                    "plural": false,
                                                    "selections": [
                                                      (v28/*: any*/),
                                                      (v24/*: any*/),
                                                      (v17/*: any*/)
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraStatusCategoryField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraStatus",
                                                    "kind": "LinkedField",
                                                    "name": "status",
                                                    "plural": false,
                                                    "selections": [
                                                      (v28/*: any*/),
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "statusId"
                                                      },
                                                      (v25/*: any*/),
                                                      (v17/*: any*/)
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraStatusField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "args": (v42/*: any*/),
                                                    "concreteType": "JiraLabelConnection",
                                                    "kind": "LinkedField",
                                                    "name": "selectedLabelsConnection",
                                                    "plural": false,
                                                    "selections": [
                                                      (v34/*: any*/),
                                                      {
                                                        "concreteType": "JiraLabelEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraLabel",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                              (v28/*: any*/),
                                                              (v48/*: any*/)
                                                            ]
                                                          }
                                                        ]
                                                      }
                                                    ],
                                                    "storageKey": "selectedLabelsConnection(first:1000)"
                                                  },
                                                  (v28/*: any*/),
                                                  (v39/*: any*/)
                                                ],
                                                "type": "JiraLabelsField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraIssueType",
                                                    "kind": "LinkedField",
                                                    "name": "issueType",
                                                    "plural": false,
                                                    "selections": [
                                                      (v32/*: any*/),
                                                      (v28/*: any*/),
                                                      (v17/*: any*/)
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraIssueTypeField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraIssue",
                                                    "kind": "LinkedField",
                                                    "name": "parentIssue",
                                                    "plural": false,
                                                    "selections": [
                                                      (v20/*: any*/),
                                                      {
                                                        "concreteType": "JiraColorField",
                                                        "kind": "LinkedField",
                                                        "name": "issueColorField",
                                                        "plural": false,
                                                        "selections": [
                                                          (v48/*: any*/),
                                                          (v17/*: any*/)
                                                        ]
                                                      },
                                                      {
                                                        "concreteType": "JiraIssueTypeField",
                                                        "kind": "LinkedField",
                                                        "name": "issueTypeField",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "issueType",
                                                            "plural": false,
                                                            "selections": [
                                                              (v49/*: any*/),
                                                              (v28/*: any*/),
                                                              (v17/*: any*/)
                                                            ]
                                                          },
                                                          (v17/*: any*/)
                                                        ]
                                                      },
                                                      {
                                                        "concreteType": "JiraSingleLineTextField",
                                                        "kind": "LinkedField",
                                                        "name": "summaryField",
                                                        "plural": false,
                                                        "selections": [
                                                          (v47/*: any*/),
                                                          (v17/*: any*/)
                                                        ]
                                                      },
                                                      (v17/*: any*/),
                                                      (v21/*: any*/),
                                                      (v50/*: any*/),
                                                      {
                                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                        "kind": "Condition",
                                                        "passingValue": false,
                                                        "selections": [
                                                          {
                                                            "args": [
                                                              {
                                                                "kind": "Literal",
                                                                "name": "ids",
                                                                "value": [
                                                                  "issuetype",
                                                                  "project",
                                                                  "summary",
                                                                  "status"
                                                                ]
                                                              }
                                                            ],
                                                            "concreteType": "JiraIssueFieldConnection",
                                                            "kind": "LinkedField",
                                                            "name": "fieldsById",
                                                            "plural": false,
                                                            "selections": [
                                                              {
                                                                "concreteType": "JiraIssueFieldEdge",
                                                                "kind": "LinkedField",
                                                                "name": "edges",
                                                                "plural": true,
                                                                "selections": [
                                                                  {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                      (v16/*: any*/),
                                                                      (v17/*: any*/),
                                                                      {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                          (v35/*: any*/),
                                                                          (v47/*: any*/)
                                                                        ],
                                                                        "type": "JiraSingleLineTextField"
                                                                      },
                                                                      {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                          (v35/*: any*/),
                                                                          {
                                                                            "concreteType": "JiraIssueType",
                                                                            "kind": "LinkedField",
                                                                            "name": "issueType",
                                                                            "plural": false,
                                                                            "selections": [
                                                                              (v17/*: any*/),
                                                                              (v51/*: any*/),
                                                                              (v28/*: any*/),
                                                                              (v49/*: any*/),
                                                                              (v22/*: any*/)
                                                                            ]
                                                                          }
                                                                        ],
                                                                        "type": "JiraIssueTypeField"
                                                                      },
                                                                      {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                          (v35/*: any*/),
                                                                          {
                                                                            "concreteType": "JiraStatus",
                                                                            "kind": "LinkedField",
                                                                            "name": "status",
                                                                            "plural": false,
                                                                            "selections": [
                                                                              (v17/*: any*/),
                                                                              {
                                                                                "concreteType": "JiraStatusCategory",
                                                                                "kind": "LinkedField",
                                                                                "name": "statusCategory",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                  (v17/*: any*/),
                                                                                  (v24/*: any*/)
                                                                                ]
                                                                              }
                                                                            ]
                                                                          }
                                                                        ],
                                                                        "type": "JiraStatusField"
                                                                      }
                                                                    ]
                                                                  }
                                                                ]
                                                              }
                                                            ],
                                                            "storageKey": "fieldsById(ids:[\"issuetype\",\"project\",\"summary\",\"status\"])"
                                                          }
                                                        ]
                                                      },
                                                      {
                                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                        "kind": "Condition",
                                                        "passingValue": true,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraIssueTypeField",
                                                            "kind": "LinkedField",
                                                            "name": "issueTypeField",
                                                            "plural": false,
                                                            "selections": [
                                                              (v35/*: any*/),
                                                              {
                                                                "concreteType": "JiraIssueType",
                                                                "kind": "LinkedField",
                                                                "name": "issueType",
                                                                "plural": false,
                                                                "selections": [
                                                                  (v51/*: any*/),
                                                                  (v22/*: any*/)
                                                                ]
                                                              }
                                                            ]
                                                          },
                                                          {
                                                            "concreteType": "JiraSingleLineTextField",
                                                            "kind": "LinkedField",
                                                            "name": "summaryField",
                                                            "plural": false,
                                                            "selections": [
                                                              (v35/*: any*/)
                                                            ]
                                                          },
                                                          {
                                                            "concreteType": "JiraStatusField",
                                                            "kind": "LinkedField",
                                                            "name": "statusField",
                                                            "plural": false,
                                                            "selections": [
                                                              (v17/*: any*/),
                                                              (v35/*: any*/),
                                                              (v26/*: any*/)
                                                            ]
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  },
                                                  (v28/*: any*/),
                                                  (v39/*: any*/)
                                                ],
                                                "type": "JiraParentIssueField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraPriority",
                                                    "kind": "LinkedField",
                                                    "name": "priority",
                                                    "plural": false,
                                                    "selections": [
                                                      (v28/*: any*/),
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "iconUrl"
                                                      },
                                                      (v17/*: any*/)
                                                    ]
                                                  },
                                                  (v28/*: any*/),
                                                  (v39/*: any*/)
                                                ],
                                                "type": "JiraPriorityField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "project",
                                                    "plural": false,
                                                    "selections": [
                                                      (v28/*: any*/),
                                                      (v20/*: any*/),
                                                      {
                                                        "concreteType": "JiraAvatar",
                                                        "kind": "LinkedField",
                                                        "name": "avatar",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "large"
                                                          }
                                                        ]
                                                      },
                                                      (v17/*: any*/)
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraProjectField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraResolution",
                                                    "kind": "LinkedField",
                                                    "name": "resolution",
                                                    "plural": false,
                                                    "selections": [
                                                      (v28/*: any*/),
                                                      (v17/*: any*/)
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraResolutionField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraSprintConnection",
                                                    "kind": "LinkedField",
                                                    "name": "selectedSprintsConnection",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraSprintEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraSprint",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                              (v17/*: any*/),
                                                              {
                                                                "kind": "ScalarField",
                                                                "name": "sprintId"
                                                              },
                                                              (v28/*: any*/),
                                                              {
                                                                "kind": "ScalarField",
                                                                "name": "state"
                                                              },
                                                              {
                                                                "kind": "ScalarField",
                                                                "name": "endDate"
                                                              }
                                                            ]
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  },
                                                  (v28/*: any*/),
                                                  (v39/*: any*/)
                                                ],
                                                "type": "JiraSprintField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v28/*: any*/),
                                                  {
                                                    "kind": "LinkedField",
                                                    "name": "user",
                                                    "plural": false,
                                                    "selections": [
                                                      (v16/*: any*/),
                                                      (v28/*: any*/),
                                                      (v52/*: any*/),
                                                      (v53/*: any*/),
                                                      (v17/*: any*/),
                                                      (v54/*: any*/),
                                                      {
                                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider",
                                                        "kind": "Condition",
                                                        "passingValue": true,
                                                        "selections": (v56/*: any*/)
                                                      },
                                                      {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                          {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": (v55/*: any*/)
                                                          }
                                                        ],
                                                        "type": "AppUser"
                                                      },
                                                      {
                                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerninrelayprovider",
                                                        "kind": "Condition",
                                                        "passingValue": true,
                                                        "selections": (v56/*: any*/)
                                                      }
                                                    ]
                                                  },
                                                  (v46/*: any*/),
                                                  (v39/*: any*/)
                                                ],
                                                "type": "JiraSingleSelectUserPickerField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraRichText",
                                                    "kind": "LinkedField",
                                                    "name": "richText",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraADF",
                                                        "kind": "LinkedField",
                                                        "name": "adfValue",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraAdfToConvertedPlainText",
                                                            "kind": "LinkedField",
                                                            "name": "convertedPlainText",
                                                            "plural": false,
                                                            "selections": [
                                                              {
                                                                "kind": "ScalarField",
                                                                "name": "plainText"
                                                              }
                                                            ]
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraRichTextField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraServiceManagementRequestType",
                                                    "kind": "LinkedField",
                                                    "name": "requestType",
                                                    "plural": false,
                                                    "selections": [
                                                      (v28/*: any*/),
                                                      (v49/*: any*/),
                                                      (v17/*: any*/)
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraServiceManagementRequestTypeField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "args": [
                                                      {
                                                        "kind": "Literal",
                                                        "name": "first",
                                                        "value": 1
                                                      }
                                                    ],
                                                    "concreteType": "JiraIssueLinkConnection",
                                                    "kind": "LinkedField",
                                                    "name": "issueLinkConnection",
                                                    "plural": false,
                                                    "selections": [
                                                      (v34/*: any*/),
                                                      {
                                                        "concreteType": "JiraIssueLinkEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraIssueLink",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                              {
                                                                "concreteType": "JiraIssue",
                                                                "kind": "LinkedField",
                                                                "name": "issue",
                                                                "plural": false,
                                                                "selections": [
                                                                  (v50/*: any*/),
                                                                  (v20/*: any*/),
                                                                  {
                                                                    "args": [
                                                                      {
                                                                        "kind": "Literal",
                                                                        "name": "ids",
                                                                        "value": [
                                                                          "statusCategory"
                                                                        ]
                                                                      }
                                                                    ],
                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldsById",
                                                                    "plural": false,
                                                                    "selections": [
                                                                      {
                                                                        "concreteType": "JiraIssueFieldEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                          {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                              (v16/*: any*/),
                                                                              {
                                                                                "kind": "InlineFragment",
                                                                                "selections": [
                                                                                  (v25/*: any*/)
                                                                                ],
                                                                                "type": "JiraStatusCategoryField"
                                                                              },
                                                                              (v17/*: any*/)
                                                                            ]
                                                                          }
                                                                        ]
                                                                      }
                                                                    ],
                                                                    "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                                  },
                                                                  {
                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                      (v23/*: any*/)
                                                                    ]
                                                                  },
                                                                  (v17/*: any*/)
                                                                ]
                                                              },
                                                              {
                                                                "kind": "ScalarField",
                                                                "name": "relationName"
                                                              },
                                                              (v17/*: any*/)
                                                            ]
                                                          }
                                                        ]
                                                      }
                                                    ],
                                                    "storageKey": "issueLinkConnection(first:1)"
                                                  }
                                                ],
                                                "type": "JiraIssueLinkField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "isStoryPointField"
                                                  },
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "number"
                                                  },
                                                  (v28/*: any*/),
                                                  {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraNumberFieldFormatConfig",
                                                        "kind": "LinkedField",
                                                        "name": "formatConfig",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "formatStyle"
                                                          },
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "formatUnit"
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  },
                                                  (v39/*: any*/)
                                                ],
                                                "type": "JiraNumberField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraCommentSummary",
                                                    "kind": "LinkedField",
                                                    "name": "commentSummary",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "canAddComment"
                                                      },
                                                      (v34/*: any*/)
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraCommentSummaryField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v28/*: any*/),
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "uri"
                                                  },
                                                  (v39/*: any*/)
                                                ],
                                                "type": "JiraUrlField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v28/*: any*/),
                                                  {
                                                    "concreteType": "JiraOption",
                                                    "kind": "LinkedField",
                                                    "name": "fieldOption",
                                                    "plural": false,
                                                    "selections": [
                                                      (v36/*: any*/),
                                                      (v48/*: any*/),
                                                      (v17/*: any*/),
                                                      (v57/*: any*/)
                                                    ]
                                                  },
                                                  (v39/*: any*/)
                                                ],
                                                "type": "JiraSingleSelectField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v28/*: any*/),
                                                  {
                                                    "concreteType": "JiraOptionConnection",
                                                    "kind": "LinkedField",
                                                    "name": "selectedOptions",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraOptionEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraOption",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                              (v17/*: any*/),
                                                              (v36/*: any*/),
                                                              (v57/*: any*/)
                                                            ]
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  },
                                                  (v39/*: any*/)
                                                ],
                                                "type": "JiraMultipleSelectField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v28/*: any*/),
                                                  {
                                                    "concreteType": "JiraOptionConnection",
                                                    "kind": "LinkedField",
                                                    "name": "selectedOptions",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraOptionEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraOption",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                              (v17/*: any*/),
                                                              (v36/*: any*/)
                                                            ]
                                                          },
                                                          (v58/*: any*/)
                                                        ]
                                                      }
                                                    ]
                                                  },
                                                  (v39/*: any*/)
                                                ],
                                                "type": "JiraCheckboxesField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v28/*: any*/),
                                                  {
                                                    "concreteType": "JiraUserConnection",
                                                    "kind": "LinkedField",
                                                    "name": "selectedUsersConnection",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraUserEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                              (v16/*: any*/),
                                                              (v54/*: any*/),
                                                              (v28/*: any*/),
                                                              (v52/*: any*/),
                                                              (v17/*: any*/),
                                                              (v53/*: any*/),
                                                              {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                  {
                                                                    "kind": "ScalarField",
                                                                    "name": "email"
                                                                  }
                                                                ],
                                                                "type": "AtlassianAccountUser"
                                                              }
                                                            ]
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  },
                                                  (v39/*: any*/)
                                                ],
                                                "type": "JiraMultipleSelectUserPickerField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v28/*: any*/),
                                                  {
                                                    "concreteType": "JiraTeamView",
                                                    "kind": "LinkedField",
                                                    "name": "selectedTeam",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "jiraSuppliedId"
                                                      },
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "jiraSuppliedName"
                                                      }
                                                    ]
                                                  },
                                                  (v39/*: any*/)
                                                ],
                                                "type": "JiraTeamViewField"
                                              },
                                              {
                                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
                                                "kind": "Condition",
                                                "passingValue": false,
                                                "selections": [
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraIssue",
                                                        "kind": "LinkedField",
                                                        "name": "issue",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraTimeTrackingField",
                                                            "kind": "LinkedField",
                                                            "name": "timeTrackingField",
                                                            "plural": false,
                                                            "selections": [
                                                              (v17/*: any*/),
                                                              (v59/*: any*/),
                                                              (v60/*: any*/),
                                                              (v35/*: any*/),
                                                              (v28/*: any*/),
                                                              (v33/*: any*/),
                                                              (v39/*: any*/)
                                                            ]
                                                          },
                                                          (v17/*: any*/)
                                                        ]
                                                      }
                                                    ],
                                                    "type": "JiraOriginalTimeEstimateField"
                                                  }
                                                ]
                                              },
                                              {
                                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
                                                "kind": "Condition",
                                                "passingValue": true,
                                                "selections": [
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraIssue",
                                                        "kind": "LinkedField",
                                                        "name": "issue",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraTimeTrackingField",
                                                            "kind": "LinkedField",
                                                            "name": "timeTrackingField",
                                                            "plural": false,
                                                            "selections": [
                                                              (v59/*: any*/),
                                                              (v60/*: any*/),
                                                              (v17/*: any*/),
                                                              (v35/*: any*/),
                                                              (v28/*: any*/),
                                                              (v33/*: any*/)
                                                            ]
                                                          },
                                                          (v17/*: any*/)
                                                        ]
                                                      },
                                                      (v39/*: any*/)
                                                    ],
                                                    "type": "JiraOriginalTimeEstimateField"
                                                  }
                                                ]
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v28/*: any*/),
                                                  {
                                                    "concreteType": "JiraOption",
                                                    "kind": "LinkedField",
                                                    "name": "selectedOption",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "alias": "label",
                                                        "kind": "ScalarField",
                                                        "name": "value"
                                                      },
                                                      (v17/*: any*/),
                                                      (v43/*: any*/)
                                                    ]
                                                  },
                                                  (v39/*: any*/)
                                                ],
                                                "type": "JiraRadioSelectField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v28/*: any*/),
                                                  {
                                                    "args": (v42/*: any*/),
                                                    "concreteType": "JiraVersionConnection",
                                                    "kind": "LinkedField",
                                                    "name": "selectedVersionsConnection",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraVersionEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraVersion",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                              (v17/*: any*/),
                                                              (v28/*: any*/),
                                                              (v43/*: any*/),
                                                              (v44/*: any*/),
                                                              (v61/*: any*/)
                                                            ]
                                                          }
                                                        ]
                                                      }
                                                    ],
                                                    "storageKey": "selectedVersionsConnection(first:1000)"
                                                  },
                                                  (v39/*: any*/)
                                                ],
                                                "type": "JiraMultipleVersionPickerField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v28/*: any*/),
                                                  (v63/*: any*/),
                                                  {
                                                    "args": (v42/*: any*/),
                                                    "concreteType": "JiraGoalConnection",
                                                    "kind": "LinkedField",
                                                    "name": "selectedGoals",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraGoalEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraGoal",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                              (v17/*: any*/),
                                                              (v20/*: any*/),
                                                              {
                                                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider",
                                                                "kind": "Condition",
                                                                "passingValue": true,
                                                                "selections": [
                                                                  (v28/*: any*/),
                                                                  {
                                                                    "kind": "ScalarField",
                                                                    "name": "status"
                                                                  }
                                                                ]
                                                              }
                                                            ]
                                                          }
                                                        ]
                                                      },
                                                      (v58/*: any*/)
                                                    ],
                                                    "storageKey": "selectedGoals(first:1000)"
                                                  },
                                                  {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                      (v30/*: any*/),
                                                      (v38/*: any*/)
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraGoalsField"
                                              },
                                              {
                                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider",
                                                "kind": "Condition",
                                                "passingValue": true,
                                                "selections": [
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      (v28/*: any*/),
                                                      (v63/*: any*/),
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "isLinkEditable"
                                                      },
                                                      {
                                                        "concreteType": "JiraTownsquareProject",
                                                        "kind": "LinkedField",
                                                        "name": "project",
                                                        "plural": false,
                                                        "selections": [
                                                          (v17/*: any*/),
                                                          {
                                                            "alias": "atlasProjectName",
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                          },
                                                          {
                                                            "alias": "atlasProjectKey",
                                                            "kind": "ScalarField",
                                                            "name": "key"
                                                          },
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "privateProject"
                                                          },
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "hasPermission"
                                                          },
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "isWorkspaceActive"
                                                          },
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "iconName"
                                                          }
                                                        ]
                                                      },
                                                      (v39/*: any*/)
                                                    ],
                                                    "type": "JiraTownsquareProjectField"
                                                  }
                                                ]
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v28/*: any*/),
                                                  {
                                                    "args": (v42/*: any*/),
                                                    "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                                                    "kind": "LinkedField",
                                                    "name": "confluenceRemoteIssueLinks",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraConfluenceRemoteIssueLink",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                              (v17/*: any*/),
                                                              (v64/*: any*/),
                                                              {
                                                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider",
                                                                "kind": "Condition",
                                                                "passingValue": true,
                                                                "selections": [
                                                                  {
                                                                    "kind": "LinkedField",
                                                                    "name": "pageContent",
                                                                    "plural": false,
                                                                    "selections": [
                                                                      (v16/*: any*/),
                                                                      {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                          (v64/*: any*/)
                                                                        ],
                                                                        "type": "JiraConfluencePageContentDetails"
                                                                      }
                                                                    ]
                                                                  }
                                                                ]
                                                              }
                                                            ]
                                                          }
                                                        ]
                                                      },
                                                      (v34/*: any*/)
                                                    ],
                                                    "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                                                  },
                                                  (v39/*: any*/)
                                                ],
                                                "type": "JiraConfluenceRemoteIssueLinksField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v28/*: any*/),
                                                  {
                                                    "concreteType": "JiraGroupConnection",
                                                    "kind": "LinkedField",
                                                    "name": "selectedGroupsConnection",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraGroupEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraGroup",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                              (v17/*: any*/),
                                                              (v28/*: any*/),
                                                              {
                                                                "kind": "ScalarField",
                                                                "name": "groupId"
                                                              }
                                                            ]
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  },
                                                  (v39/*: any*/)
                                                ],
                                                "type": "JiraMultipleGroupPickerField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraFlag",
                                                    "kind": "LinkedField",
                                                    "name": "flag",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "isFlagged"
                                                      }
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraFlagField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraWatch",
                                                    "kind": "LinkedField",
                                                    "name": "watch",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "count"
                                                      },
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "isWatching"
                                                      }
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraWatchesField"
                                              },
                                              {
                                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider",
                                                "kind": "Condition",
                                                "passingValue": true,
                                                "selections": [
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraIssue",
                                                            "kind": "LinkedField",
                                                            "name": "issue",
                                                            "plural": false,
                                                            "selections": [
                                                              (v17/*: any*/),
                                                              (v21/*: any*/),
                                                              {
                                                                "concreteType": "JiraIssueTypeField",
                                                                "kind": "LinkedField",
                                                                "name": "issueTypeField",
                                                                "plural": false,
                                                                "selections": [
                                                                  {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                      (v28/*: any*/),
                                                                      (v22/*: any*/),
                                                                      (v17/*: any*/)
                                                                    ]
                                                                  },
                                                                  (v17/*: any*/)
                                                                ]
                                                              },
                                                              {
                                                                "concreteType": "JiraParentIssueField",
                                                                "kind": "LinkedField",
                                                                "name": "parentIssueField",
                                                                "plural": false,
                                                                "selections": [
                                                                  {
                                                                    "concreteType": "JiraIssue",
                                                                    "kind": "LinkedField",
                                                                    "name": "parentIssue",
                                                                    "plural": false,
                                                                    "selections": [
                                                                      (v21/*: any*/),
                                                                      (v20/*: any*/),
                                                                      (v17/*: any*/)
                                                                    ]
                                                                  },
                                                                  (v17/*: any*/)
                                                                ]
                                                              },
                                                              (v20/*: any*/),
                                                              (v27/*: any*/),
                                                              {
                                                                "concreteType": "JiraSingleSelectUserPickerField",
                                                                "kind": "LinkedField",
                                                                "name": "assigneeField",
                                                                "plural": false,
                                                                "selections": [
                                                                  {
                                                                    "kind": "LinkedField",
                                                                    "name": "user",
                                                                    "plural": false,
                                                                    "selections": [
                                                                      (v16/*: any*/),
                                                                      (v52/*: any*/),
                                                                      (v17/*: any*/)
                                                                    ]
                                                                  },
                                                                  (v17/*: any*/)
                                                                ]
                                                              },
                                                              {
                                                                "args": (v65/*: any*/),
                                                                "kind": "LinkedField",
                                                                "name": "startDateViewField",
                                                                "plural": false,
                                                                "selections": (v67/*: any*/),
                                                                "storageKey": "startDateViewField(viewId:\"list_default\")"
                                                              },
                                                              {
                                                                "args": (v65/*: any*/),
                                                                "kind": "LinkedField",
                                                                "name": "endDateViewField",
                                                                "plural": false,
                                                                "selections": (v67/*: any*/),
                                                                "storageKey": "endDateViewField(viewId:\"list_default\")"
                                                              }
                                                            ]
                                                          },
                                                          {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                              {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                  {
                                                                    "kind": "LinkedField",
                                                                    "name": "aggregatedStartDateViewField",
                                                                    "plural": false,
                                                                    "selections": (v68/*: any*/)
                                                                  },
                                                                  {
                                                                    "kind": "LinkedField",
                                                                    "name": "aggregatedEndDateViewField",
                                                                    "plural": false,
                                                                    "selections": (v68/*: any*/)
                                                                  }
                                                                ],
                                                                "type": "JiraAggregatedTimelineField"
                                                              }
                                                            ]
                                                          }
                                                        ],
                                                        "type": "JiraTimelineVirtualField",
                                                        "abstractKey": "__isJiraTimelineVirtualField"
                                                      }
                                                    ],
                                                    "type": "JiraAggregatedTimelineField"
                                                  }
                                                ]
                                              },
                                              (v58/*: any*/)
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  (v58/*: any*/)
                                ]
                              }
                            ]
                          },
                          {
                            "condition": "isConditionalFormattingEnabled",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "concreteType": "JiraIssueFieldSetEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "JiraIssueFieldSet",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "JiraIssueFieldConnection",
                                        "kind": "LinkedField",
                                        "name": "fields",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraIssueFieldEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      {
                                                        "args": (v42/*: any*/),
                                                        "concreteType": "JiraComponentConnection",
                                                        "kind": "LinkedField",
                                                        "name": "selectedComponentsConnection",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraComponentEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                              {
                                                                "concreteType": "JiraComponent",
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                  {
                                                                    "kind": "ScalarField",
                                                                    "name": "componentId"
                                                                  }
                                                                ]
                                                              }
                                                            ]
                                                          }
                                                        ],
                                                        "storageKey": "selectedComponentsConnection(first:1000)"
                                                      }
                                                    ],
                                                    "type": "JiraComponentsField"
                                                  },
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraPriority",
                                                        "kind": "LinkedField",
                                                        "name": "priority",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "priorityId"
                                                          }
                                                        ]
                                                      }
                                                    ],
                                                    "type": "JiraPriorityField"
                                                  },
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraProject",
                                                        "kind": "LinkedField",
                                                        "name": "project",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "projectId"
                                                          }
                                                        ]
                                                      }
                                                    ],
                                                    "type": "JiraProjectField"
                                                  },
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraVersion",
                                                        "kind": "LinkedField",
                                                        "name": "version",
                                                        "plural": false,
                                                        "selections": [
                                                          (v61/*: any*/),
                                                          (v17/*: any*/)
                                                        ]
                                                      }
                                                    ],
                                                    "type": "JiraSingleVersionPickerField"
                                                  },
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraIssueType",
                                                        "kind": "LinkedField",
                                                        "name": "issueType",
                                                        "plural": false,
                                                        "selections": [
                                                          (v51/*: any*/)
                                                        ]
                                                      }
                                                    ],
                                                    "type": "JiraIssueTypeField"
                                                  },
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      {
                                                        "kind": "LinkedField",
                                                        "name": "selectedValue",
                                                        "plural": false,
                                                        "selections": (v69/*: any*/)
                                                      }
                                                    ],
                                                    "type": "JiraSingleSelectField"
                                                  },
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraSelectableValueConnection",
                                                        "kind": "LinkedField",
                                                        "name": "selectedValues",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraSelectableValueEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                              {
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": (v69/*: any*/)
                                                              }
                                                            ]
                                                          }
                                                        ]
                                                      }
                                                    ],
                                                    "type": "JiraMultipleSelectField"
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ],
                        "storageKey": "fieldSets(first:500)"
                      },
                      (v58/*: any*/)
                    ]
                  },
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "endCursor"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "startCursor"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "hasPreviousPage"
                      }
                    ]
                  },
                  {
                    "concreteType": "JiraIssueNavigatorPageInfo",
                    "kind": "LinkedField",
                    "name": "issueNavigatorPageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "firstIssuePosition"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "lastIssuePosition"
                      }
                    ]
                  },
                  {
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "maxCursors",
                        "value": 7
                      }
                    ],
                    "concreteType": "JiraPageCursors",
                    "kind": "LinkedField",
                    "name": "pageCursors",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraPageCursor",
                        "kind": "LinkedField",
                        "name": "around",
                        "plural": true,
                        "selections": (v72/*: any*/)
                      },
                      {
                        "concreteType": "JiraPageCursor",
                        "kind": "LinkedField",
                        "name": "last",
                        "plural": false,
                        "selections": (v72/*: any*/)
                      },
                      {
                        "concreteType": "JiraPageCursor",
                        "kind": "LinkedField",
                        "name": "first",
                        "plural": false,
                        "selections": [
                          (v19/*: any*/),
                          (v70/*: any*/),
                          (v71/*: any*/)
                        ]
                      }
                    ],
                    "storageKey": "pageCursors(maxCursors:7)"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "totalIssueSearchResultCount"
                  },
                  {
                    "kind": "LinkedField",
                    "name": "issueSearchError",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "messages"
                          }
                        ],
                        "type": "JiraInvalidJqlError"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v40/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "errorType"
                          }
                        ],
                        "type": "JiraInvalidSyntaxError"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v41/*: any*/),
                        "type": "JiraServerError"
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "jql"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "isCappingIssueSearchResult"
                  },
                  (v58/*: any*/),
                  {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcfrontierformulafieldd1relayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "concreteType": "JiraIssueEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v31/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "args": (v18/*: any*/),
                "filters": [
                  "scope"
                ],
                "handle": "connection",
                "key": "IssueNavigatorJiraDetailedViewPagination__issues",
                "kind": "LinkedHandle",
                "name": "issues",
                "dynamicKey": {
                  "kind": "Variable",
                  "name": "__dynamicKey",
                  "variableName": "dynamicSearchKey"
                }
              }
            ],
            "type": "JiraDetailedView"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "862c92ef7fb9eeac5cb31a0bf3a983f9bde67a5e1dcaeb68a2208370b45811f0",
    "metadata": {},
    "name": "IssueNavigatorJiraDetailedViewPaginationQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider": isBulkOpsSelectAllEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider": isReparentingEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcfrontierformulafieldd1relayprovider": isFormulaFieldD1Enabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider": isInitialiseVirtualiserStateFromRelayStoreEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcmimicflatlistrsswhileuninitialisedrelayprovider": isMimicFlatlistRssWhileUninitialisedEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreducererendersrelayprovider": isJiraListReduceRerendersEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": isJscMergedColumnEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": isJiraItrM4Exp3Enabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider": isIframePreviewPanelInSubtasksEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider": isJiraTimelineAnalyticsHarmonizationEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider": isAtlasProjectEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider": originalEstimateEditableFixFlag_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": isFieldsByIdRemoved_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider": shouldFetchAppUserType_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider": isJiraAiAgentAvatarSingleUserPickerEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider": isNinStrikethroughResolutionUpdateEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": isNumberFieldConfigurableEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider": isPlaceholderDataEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": isJiraConfluencePageContentEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider": isJiraTimelineRollupsTechnicalGateEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerninrelayprovider": isJiraAiAgentAvatarSingleUserPickerNINEnabled_provider
    }
  }
};
})();

(node as any).hash = "27958eb44f28306eb84d2d7dca4b6970";

export default node;
